export default __webpack_public_path__ + "static/media/laval9.56919dd7.jpg";